import React from "react";
import Title from "./Title";
import "./Blogs.css";
function Blogs({ scrollPositionHeader }) {
  return (
    <div className="center-div">
      {/* <Title
        scrollPositionHeader={scrollPositionHeader}
        text="Development Blogs"
      /> */}
      <h1 className="centered-title">Development Blogs</h1>
      <div>
        <div className="high-tech-box">
          <h2 className="dev-blog-header">Dev Blog 11/6 - 11/13: First Week</h2>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/hhkCj4we0bE?si=6PIzMmrsmL1iW4kX"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          <p className="dev-blog-text">
            In our first week, our goals were to define a clear objective for
            the project, and to make significant progress on the fishing element
            of the game so that users would have a clear idea of how the game
            would look and feel.
          </p>
          <p className="dev-blog-text">
            We developed the plan to make the game education-focused and for the
            user to progress in the game by unlocking different animals and
            discovering their place in the food chain. We also planned for more
            passive learning to occur through the changing of the seasons and
            through experiencing the water cycle.
          </p>
          <p className="dev-blog-text">
            During the week, we designed the outline of the landscape, added
            fishing mechanics to the world, and created a boat that the user can
            ride.
          </p>
        </div>
      </div>
      <div>
        {/* ----------------------------------------------------------------------------------------------------------*/}
        <div className="high-tech-box">
          <h2 className="dev-blog-header">
            Dev Blog 11/13 - 11/20: Second Week
          </h2>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/aEiM-KU-J4Y?si=QqeKYHGtFm_wGFsk"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          <p className="dev-blog-text">
            In our second week, we aimed to develop our experience to the point
            where the user would have a stronger sense of the environment of the
            game and the purpose of the game.
          </p>
          <p className="dev-blog-text">
            We selected the specific animals that we would like to represent in
            the game as well as made the board representing the food chain with
            all the connections between the the animals. We also added rain to
            our world, and enhanced the landscape through modeling and the
            addition of trees. The user also has the ability to teleport between
            lakes, and information appears when the user catches a fish.
          </p>
        </div>
        {/* ----------------------------------------------------------------------------------------------------------*/}
        {/* ----------------------------------------------------------------------------------------------------------*/}
        <div className="high-tech-box">
          <h2 className="dev-blog-header">
            Dev Blog 11/20 - 11/26: Third Week
          </h2>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/xHgbErBsiqk"
            title="EECS 440 - P3 Alpha"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          <p className="dev-blog-text">
            This week, we aimed to complete the majority of our VR experience.
            We playtested with another team and received valuable feedback from
            them, and also interviewed two teachers of young students who gave
            us insight into important components of educational products. With
            this advice, we had a clear idea of what our game was missing and
            also what was working well and should be developed further.
          </p>
          <p className="dev-blog-text">
            During our development, we added distinct scenery and environmental
            elements for each location, so that the player would instantly have
            a sense of the theme of the location upon teleporting there. We
            added interaction between animals in our game that mirrored the
            processes of the food chain that the player would learn about. We
            added rain and snow controls, and new types of animals in these
            alternate conditions. We also added more animal information as we
            introduced more animals into the game based on our planned food
            chain structure. Finally, we fixed a number of bugs and quality of
            life issues.
          </p>
        </div>

        <div className="high-tech-box">
          <h2 className="dev-blog-header">Dev Blog 12/1 - 12/6: Final Week</h2>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/kDdlqeZEIEk"
            title="Ecology Education Enhanced"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          <p className="dev-blog-text">
            In our final week, we worked to finish our product with a high
            degree of quality. We playtested with two more teams to get valuable
            feedback, created a marketing video, and completed our final stages
            of development.
          </p>
          <p className="dev-blog-text">
            We finished the food web by adding the final organisms into the
            world and completing the unlocking mechanics, and spread out the
            organisms to encourage the player to visit all of the lakes in order
            to complete the game. We also added instructions near the spawn
            point to inform the player how to control the game and which buttons
            to press to open or close the food web. Finally, we fixed several
            bugs and added some quality-of-life improvements, such as having the
            line-tracing change color when it hits something interactable so it
            is easier for the player to know what they can interact with. We
            also added more sound effects, for example, sound effects for
            interactions with items, and sound effects for raining. In addition,
            we also changed the water materials of the lakes to match the lakes'
            seasons.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Blogs;
